import React, { useEffect, useState } from 'react';
import { Label, Input } from 'reactstrap';
import '../../assets/style/TaskAssign.css';
import { Button, Col, Row } from 'react-bootstrap';
import MSelect from '../../components/MSelect';
import MTextField from '../../components/MTextField';
import {
  CLICK_ACTIONS,
  DEFAULT_OPTION_LOCATION_SET_TARGET,
  TASK_ACTION,
} from '../../utils/Constant';
import SearchIcon from '@mui/icons-material/Search';
import {
  ColXsMdType,
  MapOptionType,
  MUILocationFilterType,
  SelectOptionType,
} from '../../utils/Types';
import moment from 'moment';
import { leadSelector } from '../../features/leadSlice';
import MUILocationFilter from '../../components/MUILocationFilter';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { VIEW_LEADHEALTHDETAILS_HEADER } from './LeadPageHelper';
import KTable from '../../components/KTable';
import {
  Autocomplete,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import {
  getPincodeDropData,
  locationFilterSelector,
} from '../../features/locationFilterSlice';
import DatePicker from '../../components/KDatePicker';

const blankLocationHealth = {
  sl: '',
  pincode: '',
  location: '',
  district: '',
  state: null,
  city: '',
  statecode: '',
  statecd: '',
  pincodecol: '',
  did: '',
  zone: '',
  zones: '',
};
interface ICreateTaskHealthPageProps {
  leadStatus?: any;
  disabled?: any;
  leadHealthDetails?: any;
  leadHealthList?: any;
  setLeadHealthDetails: (data: any) => void;
  setLeadHealthList: (data: any) => void;
  selectedLeadTypeId: any;
  defaultLocationOptions: any;
  zoneName: any;
  stateName: any;
  districtName: any;
  villageName: any;
  locationData: any;
  inputValue: any;
  searchTerm: any;
  ifPincode: any;
  pincodeData: any;
  selectedPincodeData: any;
  setZoneName: (data: any) => void;
  setStateName: (data: any) => void;
  setDistrictName: (data: any) => void;
  setVillageName: (data: any) => void;
  setLocationData: (data: any) => void;
  setInputValue: (data: any) => void;
  setSearchTerm: (data: any) => void;
  setIfPincode: (data: any) => void;
  setPincodeData: (data: any) => void;
  setSelectedPincodeData: (data: any) => void;
  validateHealthLead: () => Promise<boolean>;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const HealthSectionPage: React.FunctionComponent<
  ICreateTaskHealthPageProps
> = ({
  leadStatus,
  disabled,
  leadHealthDetails,
  leadHealthList,
  setLeadHealthDetails,
  setLeadHealthList,
  selectedLeadTypeId,
  defaultLocationOptions,
  zoneName,
  stateName,
  districtName,
  villageName,
  locationData,
  inputValue,
  searchTerm,
  ifPincode,
  pincodeData,
  selectedPincodeData,
  setZoneName,
  setStateName,
  setDistrictName,
  setVillageName,
  setLocationData,
  setInputValue,
  setSearchTerm,
  setIfPincode,
  setPincodeData,
  setSelectedPincodeData,
  validateHealthLead,
}: ICreateTaskHealthPageProps) => {
  const leadTypeOfCover: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeOfCover;
  const leadTypeCoverage: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeCoverage;
  const leadTypeCoverageFor: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeCoverageFor;
  const [leadTypeOfCoverDropOptions, setLeadTypeOfCoverDropOptions] = useState<
    SelectOptionType[]
  >([]);
  const [leadTypeCoverageDropOptions, setLeadTypeCoverageDropOptions] =
    useState<SelectOptionType[]>([]);
  const [leadTypeCoverageForDropOptions, setleadTypeCoverageForDropOptions] =
    useState<SelectOptionType[]>([]);

  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOptionRaw: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;
  const districtData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).districtData;
  const zoneOption =
    zoneOptionRaw && zoneOptionRaw.length > 1
      ? [DEFAULT_OPTION_LOCATION_SET_TARGET, ...zoneOptionRaw]
      : zoneOptionRaw;

  const dispatch = useAppDispatch();

  useEffect(() => {
    setLeadTypeOfCoverDropOptions(leadTypeOfCover);
  }, [leadTypeOfCover]);

  useEffect(() => {
    setLeadTypeCoverageDropOptions(leadTypeCoverage);
  }, [leadTypeCoverage]);

  useEffect(() => {
    setleadTypeCoverageForDropOptions(leadTypeCoverageFor);
  }, [leadTypeCoverageFor]);

  const handleAddHealthLead = async () => {
    const isValid = await validateHealthLead();

    if (!isValid) {
      return;
    }

    console.log('locationData', locationData);

    setLeadHealthList((prev: any) => [
      ...prev,
      {
        id: Date.now(),
        ...leadHealthDetails,
        date: leadHealthDetails?.date
          ? moment(leadHealthDetails.date).format('YYYY-MM-DD')
          : '',
        timeframeOfPurchase: moment(
          leadHealthDetails?.timeframeOfPurchase
        ).format('YYYY-MM-DD'),
        state: Number(locationData.state),
        district: Number(locationData.district),
        city: Number(locationData.city),
        zone: Number(locationData.zone),
        pincode: locationData.pincode,
        zoneName,
        stateName,
        districtName,
        villageName,
        remove: 'Remove',
      },
    ]);
    console.log('villageName', villageName);
    // Clear inputs after adding
    setLeadHealthDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      typeofCover: '',
      coverage: '',
      coverageFor: '',
      AadharNumber: '',
      date: '',
      timeframeOfPurchase: '',
      everInsured: '',
      additionalInformation: '',
      typeofCoverName: '',
      coverageName: '',
      coverageForName: '',
    });
    setLocationData(blankLocationHealth);
    setInputValue('');
    setPincodeData([]);
    setSearchTerm(false);
    setSelectedPincodeData({
      label: '',
      value: '',
    });
  };
  const handleRemoveHealthLead = (id: number) => {
    setLeadHealthList((prev: any) =>
      prev.filter((item: any) => item.id !== id)
    );
  };

  const handleSearchClick = async () => {
    if (inputValue?.length == 6) {
      await dispatch(getPincodeDropData(inputValue)).then((res) => {
        console.log('res-487', res);
        if (res?.payload?.status === 'SUCCESS') {
          if (res?.payload?.data?.length > 0) {
            const data =
              res?.payload?.data[0]?.map((item: any) => ({
                ...item,
                pincode: item?.pincodeId,
                mandal: item.mandalName,
                label:
                  item.mandalName +
                  ' - ' +
                  item.villageName +
                  ' - ' +
                  item.pincodeId,
                value: item?.pincodeId,
                id: item?.pincodeId,
              })) || [];
            setIfPincode(true);
            // setSelectedPincodeData(null);
            setPincodeData(data);
          }
        }
        if (res?.payload?.status === 'FAILED') {
          setPincodeData([]);
          setIfPincode(false);
        }
      });
    } else {
      setPincodeData([]);
      setIfPincode(false);
    }
  };

  return (
    <div className="inner-div">
      <Row className="align-items-center mb-3">
        <Col xs={6}>
          <Label className="header-style mb-0">Lead Details</Label>
        </Col>

        {leadStatus == TASK_ACTION.CREATE && (
          <Col xs={6} className="text-end">
            <Button
              variant="primary"
              onClick={handleAddHealthLead}
              disabled={disabled}
            >
              Add Lead
            </Button>
          </Col>
        )}
      </Row>
      <Row className="mt-1">
        <Col xs={12} md={4}>
          <MTextField
            label="Lead First Name"
            required
            value={leadHealthDetails?.firstname ?? ''}
            onChange={(e) => {
              const inputValue = e.target.value;
              setLeadHealthDetails({
                ...leadHealthDetails,
                firstname: inputValue,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4}>
          <MTextField
            label="Lead Last Name"
            required={true}
            value={leadHealthDetails?.lastname ?? ''}
            onChange={(e) => {
              const inputValue = e.target.value;
              setLeadHealthDetails({
                ...leadHealthDetails,
                lastname: inputValue,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin">
          <MTextField
            label="Contact Number"
            required
            value={leadHealthDetails?.contactNumber}
            onChange={(data) => {
              if (data.target.value.length <= 10) {
                setLeadHealthDetails({
                  ...leadHealthDetails,
                  contactNumber: data.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <MTextField
            label="Alternate Contact Number"
            required={false}
            value={leadHealthDetails?.alternateContactNumber}
            onChange={(data) => {
              if (data.target.value.length <= 10) {
                setLeadHealthDetails({
                  ...leadHealthDetails,
                  alternateContactNumber: data.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={12} md={5}>
          {leadStatus == TASK_ACTION.CREATE ? (
            <Autocomplete
              open={ifPincode}
              onOpen={() => setIfPincode(true)}
              onClose={() => setIfPincode(false)}
              options={pincodeData}
              getOptionLabel={(option) => String(option?.label)}
              value={selectedPincodeData ?? null}
              inputValue={inputValue}
              onInputChange={(event, newValue, reason) => {
                if (reason !== 'reset') {
                  const safeValue =
                    typeof newValue === 'string' ? newValue : '';
                  console.log('safeValue', safeValue);
                  setInputValue(safeValue);
                }
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={async (event, newValue) => {
                console.log('newValue', newValue);
                if (newValue) {
                  const validZoneIds =
                    (await zoneOption.map((zone) => zone.value)) || [];
                  const validStateIds =
                    (await Object.values(allStates).flatMap((group) =>
                      group.map((item) => item.value)
                    )) || [];
                  const districtsLength =
                    (await Object.keys(districtData).length) ?? 0;
                  if (
                    !validZoneIds.includes(String(newValue.zoneId)) ||
                    !validStateIds.includes(String(newValue.stateId)) ||
                    districtsLength == 0
                  ) {
                    alert('This location isn’t within your assigned region');
                    setInputValue('');
                    setPincodeData([]);
                    setLocationData(blankLocationHealth);
                    return;
                  }
                  setSearchTerm(true);
                  setSelectedPincodeData(newValue);
                  setLocationData({
                    ...locationData,
                    zone: newValue.zoneId,
                    state: newValue.stateId,
                    district: newValue.districtId,
                    city: newValue.villageId,
                    pincode: newValue.pincode,
                  });
                  setZoneName(newValue.zoneName);
                  setStateName(newValue.stateName);
                  setDistrictName(newValue.districtName);
                  setVillageName(
                    newValue.mandalName
                      ? newValue.mandalName + '-' + newValue.villageName
                      : newValue.villageName
                  );
                } else {
                  setInputValue('');
                  setPincodeData([]);
                  setLocationData(blankLocationHealth);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Pincode"
                  InputLabelProps={{
                    style: { fontSize: '0.8rem' },
                  }}
                  error={
                    inputValue !== '' &&
                    (!/^\d{6}$/.test(inputValue) ||
                      Number(inputValue) < 100001 ||
                      Number(inputValue) > 999999)
                  }
                  helperText={
                    inputValue !== '' &&
                    (!/^\d{6}$/.test(inputValue) ||
                      Number(inputValue) < 100001 ||
                      Number(inputValue) > 999999)
                      ? 'Enter a valid 6-digit pincode between 100001 and 999999'
                      : ''
                  }
                  variant="outlined"
                  id="searchPincode"
                  required
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        <InputAdornment position="end">
                          <IconButton onClick={handleSearchClick}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      </>
                    ),
                  }}
                />
              )}
              disabled={false}
            />
          ) : (
            <MTextField
              label="Pincode"
              required
              value={locationData.pincode ?? ''}
              numberOnly
              disabled
            />
          )}
        </Col>
      </Row>
      <div className="mt-3">
        <MUILocationFilter
          size={{
            zone: colSize,
            state: colSize,
            district: colSize,
            city: colSize,
          }}
          filterData={{
            zone: locationData.zone,
            state: locationData.state,
            district: locationData.district,
            city: locationData.city,
          }}
          setLocationFilter={(filter: MUILocationFilterType) => {
            setLocationData({
              ...locationData,
              zone: filter.zone,
              state: filter.state,
              district: filter.district,
              city: filter.city,
              pincode: filter.pincode ?? '',
            });
          }}
          disabled={disabled}
          required={true}
          defaultLocationOptions={defaultLocationOptions}
          selectedLeadTypeId={selectedLeadTypeId}
          setZoneName={(data) => setZoneName(data)}
          setStateName={(data) => setStateName(data)}
          setDistrictName={(data) => setDistrictName(data)}
          setVillageName={(data) => setVillageName(data)}
          setInputValue={(data: any) => {
            setInputValue(String(data));
          }}
          searchTerm={searchTerm}
          setSearchTerm={(data: any) => {
            setSearchTerm(data);
          }}
        />
      </div>
      <Row>
        <Col xs={12} md={4} className="col-margin">
          <MSelect
            label="Type of cover"
            required
            disabled={disabled}
            options={leadTypeOfCoverDropOptions}
            value={leadHealthDetails?.typeofCover ?? ''}
            onChange={async (e) => {
              const selectedTypeOfCover =
                await leadTypeOfCoverDropOptions?.find(
                  (option: any) =>
                    Number(option.value) === Number(e.target.value)
                );
              setLeadHealthDetails({
                ...leadHealthDetails,
                typeofCover: Number(e.target.value),
                typeofCoverName: selectedTypeOfCover?.label || '',
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin">
          <MSelect
            label="Coverage"
            required
            disabled={disabled}
            options={leadTypeCoverageDropOptions}
            value={leadHealthDetails?.coverage ?? ''}
            onChange={async (e) => {
              const selectedCoverage = await leadTypeCoverageDropOptions?.find(
                (option: any) => Number(option.value) === Number(e.target.value)
              );
              setLeadHealthDetails({
                ...leadHealthDetails,
                coverage: Number(e.target.value),
                coverageName: selectedCoverage?.label || '',
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin">
          <MSelect
            label="Coverage For"
            required
            disabled={disabled}
            options={leadTypeCoverageForDropOptions}
            value={leadHealthDetails?.coverageFor ?? ''}
            onChange={async (e) => {
              const selectedCoverageFor =
                await leadTypeCoverageForDropOptions?.find(
                  (option: any) =>
                    Number(option.value) === Number(e.target.value)
                );
              setLeadHealthDetails({
                ...leadHealthDetails,
                coverageFor: Number(e.target.value),
                coverageForName: selectedCoverageFor?.label || '',
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-4">
          <MTextField
            label="Aadhar number"
            required={false}
            value={leadHealthDetails?.AadharNumber}
            onChange={(e) => {
              if (e.target.value.length <= 12) {
                setLeadHealthDetails({
                  ...leadHealthDetails,
                  AadharNumber: e.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <DatePicker
            label="Date of birth"
            disabled={disabled}
            required={true}
            allowTyping={true}
            value={leadHealthDetails?.date}
            maxDate={moment().toDate()}
            onChange={(date) => {
              setLeadHealthDetails({
                ...leadHealthDetails,
                date: date,
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <DatePicker
            label="Timeframe of purchase"
            disabled={disabled}
            required={true}
            value={leadHealthDetails?.timeframeOfPurchase}
            minDate={moment().toDate()}
            maxDate={moment().add(2, 'years').toDate()}
            onChange={(date) => {
              setLeadHealthDetails({
                ...leadHealthDetails,
                timeframeOfPurchase: date,
              });
            }}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <div className="d-flex flex-column">
            <Label
              className="mb-2"
              style={{
                fontSize: '0.8rem',
                fontWeight: 400,
                color: 'rgba(0, 0, 0, 0.6)',
              }}
            >
              Ever Insured
            </Label>

            <RadioGroup
              row
              name="everInsured"
              value={leadHealthDetails?.everInsured ?? ''}
              onChange={(e) => {
                setLeadHealthDetails({
                  ...leadHealthDetails,
                  everInsured: e.target.value,
                });
              }}
            >
              <FormControlLabel
                value="yes"
                control={<Radio size="small" />}
                label="Yes"
                disabled={disabled}
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '0.8rem',
                  },
                }}
              />

              <FormControlLabel
                value="no"
                control={<Radio size="small" />}
                label="No"
                disabled={disabled}
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '0.8rem',
                  },
                }}
              />
            </RadioGroup>
          </div>
        </Col>
        <Col xs={12} md={4} className="activity-log-margin create-input">
          <div className="mb-2">
            <Label
              for="comment"
              className="mt-2"
              style={{
                fontSize: '0.8rem',
                fontWeight: 400,
                color: 'rgba(0, 0, 0, 0.6)',
              }}
            >
              Additional information
            </Label>
            <Input
              id="AdditionalInformation"
              name="AdditionalInformation"
              type="textarea"
              value={leadHealthDetails?.additionalInformation}
              maxLength={500}
              className="rounded border model-comment-area comment-input"
              onChange={(event) => {
                setLeadHealthDetails({
                  ...leadHealthDetails,
                  additionalInformation: event.target.value,
                });
              }}
              readOnly={disabled}
              style={
                disabled
                  ? {
                      color: '#999',
                    }
                  : {}
              }
            />
          </div>
        </Col>
      </Row>

      {leadHealthList.length > 0 ? (
        <Row className="mt-4">
          <Col xs={12} md={12}>
            <KTable
              data={leadHealthList}
              tableParentClass=""
              columnHeader={VIEW_LEADHEALTHDETAILS_HEADER}
              isLoading={false}
              showNoDataFoundMsg={false}
              onAction={(action, rowData) => {
                if (rowData?.action === CLICK_ACTIONS.DELETE) {
                  handleRemoveHealthLead(action.id);
                }
              }}
            />
          </Col>
        </Row>
      ) : null}
    </div>
  );
};

export default HealthSectionPage;
